import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-14cf010a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cs-container",
  style: {"min-width":"1400px"}
}
const _hoisted_2 = {
  key: 0,
  class: "flex items-end mb-6 px-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-bold" }, "견적서", -1))
const _hoisted_4 = { class: "ml-2 text-desc text-lg font-normal" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flex fi fi-rs-print text-2xl" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "w-full h-full flex"
}
const _hoisted_8 = { class: "relative w-full" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center text-lg font-semibold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-cloud-upload-alt text-xl" }),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "STL, STP, STEP 파일 업로드")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-80 m-auto mt-2 cs-caption" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fi fi-br-exclamation mr-1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-left" }, [
    /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"1.3"} }, [
      /*#__PURE__*/_createTextVNode(" 최대 10개 모델 업로드 가능합니다."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("해당 영역에 드래그&드롭으로 업로드 가능합니다. ")
    ])
  ])
], -1))
const _hoisted_15 = { class: "flex justify-center mt-6" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-3 text-default" }, "단위선택", -1))
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "border-l border-input" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-sr-cloud-upload-alt drop-area-icon text-white text-4xl md:text-7xl" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drop-area-desc text-white" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-semibold md:text-lg" }, "파일을 업로드하려면 여기에 드롭하세요.")
], -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "items-center justify-center bounding-loader rounded-md"
}
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"loader-boxs\" data-v-14cf010a><div class=\"scene\" data-v-14cf010a><div class=\"plane\" data-v-14cf010a><div class=\"cube cube--0\" data-v-14cf010a><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div></div><div class=\"shadow shadow--0\" data-v-14cf010a></div><div class=\"cube cube--1\" data-v-14cf010a><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div></div><div class=\"shadow shadow--1\" data-v-14cf010a></div><div class=\"cube cube--2\" data-v-14cf010a><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div></div><div class=\"shadow shadow--2\" data-v-14cf010a></div><div class=\"cube cube--3\" data-v-14cf010a><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div></div><div class=\"shadow shadow--3\" data-v-14cf010a></div><div class=\"cube cube--4\" data-v-14cf010a><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div></div><div class=\"shadow shadow--4\" data-v-14cf010a></div><div class=\"cube cube--5\" data-v-14cf010a><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div></div><div class=\"shadow shadow--5\" data-v-14cf010a></div><div class=\"cube cube--6\" data-v-14cf010a><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div></div><div class=\"shadow shadow--6\" data-v-14cf010a></div><div class=\"cube cube--7\" data-v-14cf010a><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div><div class=\"cube__side\" data-v-14cf010a></div></div><div class=\"shadow shadow--7\" data-v-14cf010a></div></div></div></div>", 1)
const _hoisted_25 = { class: "bounding-loader-text text-center" }
const _hoisted_26 = {
  key: 0,
  class: "text-lg"
}
const _hoisted_27 = {
  key: 1,
  class: "text-lg"
}
const _hoisted_28 = {
  class: "px-2",
  style: {"min-width":"330px","max-width":"330px"}
}
const _hoisted_29 = { class: "estimate-content overflow-hidden w-full border border-line rounded-md" }
const _hoisted_30 = { class: "flex relative items-center justify-center py-3 bg-black" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sub-logo",
  src: _imports_0
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flex fi fi-br-exit text-white" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "px-7 py-4 bg-deepgray text-gray" }
const _hoisted_35 = { class: "flex" }
const _hoisted_36 = { class: "w-full text-center" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-cubes1" }),
  /*#__PURE__*/_createTextVNode("모델")
], -1))
const _hoisted_38 = { class: "ml-2" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-line" }, null, -1))
const _hoisted_40 = { class: "w-full text-center" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-box-open-full1" }),
  /*#__PURE__*/_createTextVNode("수량")
], -1))
const _hoisted_42 = { class: "ml-2" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4 mb-4 border-b border-line" }, null, -1))
const _hoisted_44 = { class: "flex items-center h-5" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-user text-lg" }, null, -1))
const _hoisted_46 = { class: "ml-3" }
const _hoisted_47 = { class: "flex items-center mt-2 h-5" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-building text-lg" }, null, -1))
const _hoisted_49 = { class: "ml-3" }
const _hoisted_50 = { class: "flex items-center mt-2 h-5" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-envelope-open text-lg" }, null, -1))
const _hoisted_52 = { class: "ml-3" }
const _hoisted_53 = { class: "flex items-center mt-2 h-5" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-rr-mobile-notch text-lg" }, null, -1))
const _hoisted_55 = { class: "ml-3" }
const _hoisted_56 = {
  key: 0,
  class: "mt-5 text-right text-sm"
}
const _hoisted_57 = { class: "py-6 px-7 bg-white border-b border-line" }
const _hoisted_58 = { class: "items-center font-normal flex justify-between" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-placeholder" }, "출력 비용", -1))
const _hoisted_60 = {
  class: "cs-form flex w-40",
  "data-height": "s"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "원", -1))
const _hoisted_62 = { class: "items-center mt-3 font-normal flex justify-between" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-placeholder" }, "후처리 비용", -1))
const _hoisted_64 = {
  class: "cs-form flex w-40",
  "data-height": "s"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "원", -1))
const _hoisted_66 = { class: "items-center mt-3 font-normal flex justify-between" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-placeholder" }, "도색 비용", -1))
const _hoisted_68 = {
  class: "cs-form flex w-40",
  "data-height": "s"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "원", -1))
const _hoisted_70 = { class: "items-center mt-3 font-normal flex justify-between" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-placeholder" }, "배송 비용", -1))
const _hoisted_72 = {
  class: "cs-form flex w-40",
  "data-height": "s"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "원", -1))
const _hoisted_74 = { class: "flex justify-between mt-6 font-normal" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-placeholder" }, "동시제작 할인비용", -1))
const _hoisted_76 = { class: "py-8 px-7 bg-white" }
const _hoisted_77 = { class: "font-normal flex justify-between" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-1" }, "총 비용", -1))
const _hoisted_79 = { class: "text-right text-4xl text-second font-bold" }
const _hoisted_80 = { class: "pt-5 pb-5 px-7 bg-white" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "견적서 삭제", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_processes = _resolveComponent("processes")!
  const _component_admin_model = _resolveComponent("admin-model")!
  const _component_loader_button = _resolveComponent("loader-button")!
  const _component_modal_analysis = _resolveComponent("modal-analysis")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      ref: "inputFileData",
      type: "file",
      multiple: "",
      charset: "utf-8",
      accept: ".stp, .step, .stl",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeInputFile && _ctx.changeInputFile(...args)))
    }, null, 544), [
      [_vShow, false]
    ]),
    (_ctx.estimate.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, "no." + _toDisplayString(_ctx.estimate.id), 1),
          _createElementVNode("button", {
            class: "flex ml-5",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPrint && _ctx.onPrint(...args)))
          }, _hoisted_6)
        ]))
      : _createCommentVNode("", true),
    (_ctx.estimate.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.isShowProcesses)
              ? (_openBlock(), _createBlock(_component_processes, {
                  key: 0,
                  onOnShow: _ctx.onShowProcesses,
                  currentModel: _ctx.selectedModel
                }, null, 8, ["onOnShow", "currentModel"]))
              : _createCommentVNode("", true),
            (!_ctx.isShowProcesses)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.models, (model) => {
                    return (_openBlock(), _createBlock(_component_admin_model, {
                      key: model.id,
                      model: model,
                      onOnShowCompanys: _ctx.onShowCompanys
                    }, null, 8, ["model", "onOnShowCompanys"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  ref: "dragDropContainer",
                  class: "relative w-full py-8 border border-line rounded-md bg-white text-center upload-area",
                  onDragenter: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragEnter && _ctx.onDragEnter(...args)), ["prevent"])),
                  onDragend: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragEnd && _ctx.onDragEnd(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["w-80 m-auto cs-btn cs-pd-btn-sm", _ctx.isEstimateSubmit ? 'cs-btn-disabled' : 'cs-btn-second']),
                      disabled: _ctx.isEstimateSubmit,
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.inputFileFocus && _ctx.inputFileFocus(...args)))
                    }, _hoisted_13, 10, _hoisted_11),
                    _hoisted_14
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["px-4 py-2 border-t border-b border-l border-input rounded-l-full", ['mm' === _ctx.unit ? 'bg-white' : 'unit-unactive']]),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onUnit('mm')))
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["", ['mm' === _ctx.unit ? 'font-semibold' : 'text-placeholder']])
                          }, "mm", 2)
                        ], 2),
                        _hoisted_19,
                        _createElementVNode("button", {
                          class: _normalizeClass(["px-4 py-2 border-t border-b border-r border-input rounded-r-full", ['inch' === _ctx.unit ? 'bg-white' : 'unit-unactive']]),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onUnit('inch')))
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["", ['inch' === _ctx.unit ? 'font-semibold' : 'text-placeholder']])
                          }, "inch", 2)
                        ], 2)
                      ])
                    ])
                  ]),
                  (_ctx.isDraging)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "drop-area",
                        ref: "dropContent",
                        id: "dropContent",
                        onDrop: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"])),
                        onDragenter: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
                        onDragover: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
                        onDragleave: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args)), ["stop"]))
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["drop-area-inner", {active: _ctx.isDraging}])
                        }, _hoisted_22, 2)
                      ], 544))
                    : _createCommentVNode("", true),
                  (_ctx.AnalysisStatus.Pass !== _ctx.isEnabled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("div", _hoisted_25, [
                          (_ctx.AnalysisStatus.Processing === _ctx.isEnabled)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_26, " 초기화 중 입니다, 잠시만 기다려주세요. "))
                            : _createCommentVNode("", true),
                          (_ctx.AnalysisStatus.Fail === _ctx.isEnabled)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_27, " 관리자 설정이 필요합니다, 관리자에게 문의해주세요. "))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 544))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("button", {
                  class: "header-right-btn cs-icon-btn black",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onGoToList && _ctx.onGoToList(...args)))
                }, _hoisted_33)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.models.length) + "개", 1)
                  ]),
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.totalQua) + "개", 1)
                  ])
                ]),
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.estimate.clientName), 1)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.estimate.clientCompany), 1)
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.estimate.clientEmail), 1)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.estimate.clientPhone), 1)
                ]),
                (_ctx.estimate.createdAt)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_ctx.dateConvertYMDHM(new Date(_ctx.estimate.createdAt).getTime() / 1000)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createElementVNode("div", _hoisted_60, [
                    _withDirectives(_createElementVNode("input", {
                      class: "",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.estimateBuildCost) = $event)),
                      onKeyup: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onBuildCost && _ctx.onBuildCost(...args))),
                      type: "text",
                      placeholder: "0"
                    }, null, 544), [
                      [_vModelText, _ctx.estimateBuildCost]
                    ]),
                    _hoisted_61
                  ])
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("div", _hoisted_64, [
                    _withDirectives(_createElementVNode("input", {
                      class: "",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.estimatePPCost) = $event)),
                      onKeyup: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onPostProcessCost && _ctx.onPostProcessCost(...args))),
                      type: "text",
                      placeholder: "0"
                    }, null, 544), [
                      [_vModelText, _ctx.estimatePPCost]
                    ]),
                    _hoisted_65
                  ])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _hoisted_67,
                  _createElementVNode("div", _hoisted_68, [
                    _withDirectives(_createElementVNode("input", {
                      class: "",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.estimatePaintCost) = $event)),
                      onKeyup: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onPaintCost && _ctx.onPaintCost(...args))),
                      type: "text",
                      placeholder: "0"
                    }, null, 544), [
                      [_vModelText, _ctx.estimatePaintCost]
                    ]),
                    _hoisted_69
                  ])
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _hoisted_71,
                  _createElementVNode("div", _hoisted_72, [
                    _withDirectives(_createElementVNode("input", {
                      class: "",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.estimateSippingCost) = $event)),
                      onKeyup: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onShippingCost && _ctx.onShippingCost(...args))),
                      type: "text",
                      placeholder: "0"
                    }, null, 544), [
                      [_vModelText, _ctx.estimateSippingCost]
                    ]),
                    _hoisted_73
                  ])
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _hoisted_75,
                  _createElementVNode("p", {
                    class: _normalizeClass(["text-right", 0 > _ctx.estimate.discountCost * -1 ? 'text-danger' : ''])
                  }, _toDisplayString(_ctx.discountCost) + " 원 ", 3)
                ])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _hoisted_78,
                  _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.totalCost) + " 원", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createVNode(_component_loader_button, {
                  ref: "next",
                  class: "w-full cs-pd-btn",
                  cssButton: 'cs-btn-danger',
                  onClick: _ctx.onDelete
                }, {
                  title: _withCtx(() => [
                    _hoisted_81
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_loader_button, {
                  ref: "submit",
                  class: "w-full mt-3 cs-pd-btn",
                  cssButton: 'cs-btn-base',
                  onClick: _ctx.onSubmit
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("span", null, "견적서 " + _toDisplayString(_ctx.estimate.isActive ? "수정" : "제출"), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isVisibleViewer)
      ? (_openBlock(), _createBlock(_component_modal_analysis, {
          key: 2,
          model: _ctx.currentModel
        }, null, 8, ["model"]))
      : _createCommentVNode("", true)
  ]))
}